import type { OffsetUnit } from "./interval";

const offsetUnitMapping = {
  day: { one: "day", any: "days" },
  days: { one: "day", any: "days" },
  week: { one: "week", any: "weeks" },
  weeks: { one: "week", any: "weeks" },
  month: { one: "month", any: "months" },
  months: { one: "month", any: "months" },
  year: { one: "year", any: "years" },
  years: { one: "year", any: "years" },
};

function unitWithPlurality(offset: [OffsetUnit, number]): string {
  return Math.abs(offset[1]) === 1
    ? offsetUnitMapping[offset[0]]["one"]
    : offsetUnitMapping[offset[0]]["any"];
}

function nUnits(offset: [OffsetUnit, number]): string {
  return `${Math.abs(offset[1])} ${unitWithPlurality(offset)}`;
}

function beforeOrAfter(offset: [OffsetUnit, number]): string {
  return offset[1] > 0 ? "after" : "before";
}

export function offsetSentence(offsets: [OffsetUnit, number][]): string {
  if (offsets.length === 0) return "";

  const offset1 = offsets[0]!;
  if (offsets.length === 1) {
    return `${nUnits(offset1)} ${beforeOrAfter(offset1)}`;
  }

  const offset2 = offsets[1]!;
  if (offset1[1] > 0 && offset2[1] > 0) {
    return `${nUnits(offset1)}, ${nUnits(offset2)} after`;
  }
  if (offset1[1] < 0 && offset2[1] < 0) {
    return `${nUnits(offset1)}, ${nUnits(offset2)} before`;
  }

  return offsets.map((o) => `${nUnits(o)} ${beforeOrAfter(o)}`).join(", ");
}
